import { profileActionTypes } from "../actions/index";

const initialState = {
    data: undefined,
    isLoad: false
}
export const portfolioReducer = (state = initialState, action) => {
    switch (action.type) {
        case profileActionTypes.PORTFOLIO_REQUEST:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}